import React, { Children, useState } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Swipe from 'react-easy-swipe';
import Isvg from 'react-inlinesvg';
import Dot from 'components/Dot';
import { ICONS } from 'constants/icons';
import { SvgArrow } from 'components/Svgs';
import { bem } from 'helpers/class-name';
import appMessages from 'features/App/App.messages';
import { intlShape } from 'constants/propTypes';
import './SlideshowModal.scss';

const { block, element } = bem('slideshow-modal');

const SlideshowModal = ({ children, intl, onClose }) => {
  const [index, setIndex] = useState(0);
  const slides = Children.toArray(children);

  const leftDisabled = index === 0;

  const goRight = event =>
    index === slides.length - 1 ? onClose(event) : setIndex(Math.min(index + 1, slides.length - 1));
  const goLeft = () => setIndex(Math.max(index - 1, 0));

  return (
    <aside className={block()}>
      <header className={element('header')}>
        <button className={element('button')} type="button" onClick={onClose}>
          <Isvg title={intl.formatMessage(appMessages.close)} src={ICONS.cross} />
        </button>
      </header>

      <Swipe className={element('slides')} onSwipeLeft={goRight} onSwipeRight={goLeft}>
        {slides.map((slide, slideIndex) => {
          const active = index === slideIndex;
          return (
            <div
              key={slide.key}
              className={element('slide', { active })}
              style={{
                transform: `translateX(-${index * 100}%) scale(${active ? 1 : 0.75})`,
              }}>
              {slide}
            </div>
          );
        })}
      </Swipe>
      <footer className={element('footer')}>
        <button
          className={element('button')}
          type="button"
          onClick={() => setIndex(Math.max(index - 1, 0))}
          disabled={leftDisabled}>
          <SvgArrow
            title={intl.formatMessage(appMessages.left)}
            theme={leftDisabled ? 'disabled' : 'dark'}
            direction="left"
          />
        </button>
        <div className={element('dots')}>
          {slides.map(({ key }, slideIndex) => (
            <Dot key={key} color={index === slideIndex ? Dot.COLORS.DARK : Dot.COLORS.LIGHT} />
          ))}
        </div>
        <button
          className={element('button')}
          type="button"
          onClick={event =>
            index === slides.length - 1 ? onClose(event) : setIndex(Math.min(index + 1, slides.length - 1))
          }>
          <SvgArrow title={intl.formatMessage(appMessages.right)} theme="dark" direction="right" />
        </button>
      </footer>
    </aside>
  );
};

SlideshowModal.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
  intl: intlShape,
};

export default injectIntl(SlideshowModal);
